import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "frame"];
  static values = { url: String, minQueryLength: Number };

  connect() {
    this.#fetchSuggestions();
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  suggest() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.#fetchSuggestions(), 250);
  }

  #fetchSuggestions() {
    const query = this.inputTarget.value.trim();
    if (query.length < this.minQueryLengthValue) {
      this.frameTarget.removeAttribute("src");
      this.frameTarget.innerHTML = "";
      return;
    }

    this.frameTarget.src = `${this.urlValue}?query=${encodeURIComponent(query)}`;
  }
}
